export const config = {
  src: [
    'audiosprites/audio.ogg',
    'audiosprites/audio.mp3',
  ],
  sprite: {
    big_win: [
      0,
      4726.71201814059,
    ],
    button_spin: [
      6000,
      1394.6485260770976,
    ],
    end_free_spin: [
      9000,
      4360.997732426304,
    ],
    free_bet_big_win: [
      15000,
      1377.2335600907013,
    ],
    free_bet_mega_win: [
      18000,
      2213.151927437643,
    ],
    free_bet_total_win: [
      22000,
      979.591836734695,
    ],
    free_bet_ultra_win: [
      24000,
      1319.1836734693893,
    ],
    free_spin_ambient: [
      27000,
      26716.00907029479,
    ],
    free_spin_popup: [
      55000,
      5861.587301587299,
    ],
    free_spin_start: [
      62000,
      4427.75510204082,
    ],
    inside_buttons: [
      68000,
      242.35827664399778,
    ],
    main_ambient: [
      70000,
      48626.938775510214,
    ],
    mega_win: [
      120000,
      4950.204081632648,
    ],
    outside_buttons: [
      126000,
      72.5623582766417,
    ],
    reel_spin: [
      128000,
      2008.526077097514,
    ],
    reel_stop_01: [
      132000,
      201.72335600906877,
    ],
    reel_stop_02: [
      134000,
      201.72335600906877,
    ],
    reel_stop_03: [
      136000,
      184.30839002266453,
    ],
    reel_stop_04: [
      138000,
      169.79591836735608,
    ],
    reel_stop_05: [
      140000,
      175.60090702949083,
    ],
    regular_win: [
      142000,
      1403.3560090703077,
    ],
    tap_to_play: [
      145000,
      5286.893424036293,
    ],
    ultra_win: [
      152000,
      4506.122448979596,
    ],
  },
}
